import { createSlice } from "@reduxjs/toolkit"
import { initialState } from "./constants"
import { initializeClientApplication } from "./thunks"

// provides the ability to capture the state of external systems such as our backend processing servers
const slice = createSlice({
    name: "systems",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initializeClientApplication.pending, (state) => {
                state.isInitializingClientApplication = true
            })
            .addCase(initializeClientApplication.rejected, (state) => {
                state.isInitializingClientApplication = false
                state.clientConfiguration = undefined
            })
            .addCase(initializeClientApplication.fulfilled, (state, action) => {
                state.clientConfiguration = action.payload
            })
    },
})

export default slice.reducer
